import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Footer.css';

export default function Footer() {
	const location = useLocation();
	const navigate = useNavigate();

	return (
		<div id="footer" className="footer">
			<div className="footer-contact-div">
				<div className="footer-subheading">Any Question?</div>
				<div className="footer-heading">Contact Us</div>
				<a
					href="tel:+1-800-622-5311"
					className="footer-link w-inline-block"
				>
					<div className="text-block-6">
						Toll-Free: 1-800-622-5311
					</div>
				</a>
				<a
					href="tel:+1-250-285-2201"
					className="footer-link w-inline-block"
				>
					<div className="text-block-6">Local: 250-285-2201</div>
				</a>
				<a
					href="mailto:info@thehighpoint.ca"
					className="footer-link w-inline-block"
				>
					<div className="text-block-6">
						Email: info@thehighpoint.ca
					</div>
				</a>
				<a
					className="footer-link w-inline-block"
					href="https://maps.app.goo.gl/xBZjc2ZM1itpQBf16"
					target="_blank"
					rel="noopener noreferrer"
				>
					<div className="text-block-6">
						725 Quathiaski Cove Rd
						<br />
						Quathiaski Cove, BC · V0P 0A8
					</div>
				</a>
			</div>
			<div className="footer-nav-div">
				<div className="footer-nav-block">
					<div className="footer-subheading">Menu</div>
					<div className="footer-nav-sub-block">
						<Link
							to="/"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">Home</div>
						</Link>
						<Link
							to="/rooms"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">Rooms</div>
						</Link>
						<a
							href="https://live.ipms247.com/booking/book-rooms-426634"
							className="footer-link w-inline-block"
							target="_blank"
							rel="noopener noreferrer"
						>
							<div className="text-block-6">Booking</div>
						</a>
						<Link
							to="/quadra-island"
							aria-current="page"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">Quadra Island</div>
						</Link>
						<Link
							to="/contact"
							aria-current="page"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">Contact Us</div>
						</Link>
					</div>
				</div>
				<div className="footer-nav-block">
					<div className="footer-subheading">Rooms</div>
					<div className="footer-nav-sub-block">
						<Link
							to="/room/double-room"
							aria-current="page"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">Double Room</div>
						</Link>
						<Link
							to="/room/king-deluxe"
							aria-current="page"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">King Deluxe</div>
						</Link>
						<Link
							to="/room/queen-suite-a"
							aria-current="page"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">Queen Suite A</div>
						</Link>
						<Link
							to="/room/queen-suite-b"
							aria-current="page"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">Queen Suite B</div>
						</Link>
						<Link
							to="/room/standard-queen"
							aria-current="page"
							className="footer-link w-inline-block w--current"
						>
							<div className="text-block-6">Standard Queen</div>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
